export const ROUTE_PATH = '/clean/owner/calendar' as const
